import React from 'react';
import {
  Box,
  Chip,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  alpha,
  lighten,
  useTheme,
} from '@mui/material';
import PersonAddIcon from '@mui/icons-material/PersonAdd';

import EmployeeName from '../../../components/EmployeeName';
import EmptyRow from './EmptyRow';
import IdCardIndicator from './IdCardIndicator';
import SectionHeader from './SectionHeader';
import { formatCurrency } from './utils';

function displayName(row) {
  return `${row.title || ''}${row.firstname} ${row.lastname}`.trim();
}

// ตารางแสดงคนที่ HR เพิ่มเองเฉพาะเดือนนี้ (SsoMonthlyAddition ผ่าน MonthlyAdditionModal) — ไม่ใช่ real
// payroll period เลยไม่มี periods[]/breakdown ให้ expand แบบ EmployeeGroupTable, เป็นตารางแบบเดียวกับ
// NoCheckinTable (อ่านอย่างเดียว) แก้ไข/ลบทำผ่านปุ่ม "เพิ่มคน" ที่หน้ารายการเดือนแทน ไม่มีปุ่มในนี้
export default function MonthlyAdditionTable({ rows, accentColor }) {
  const theme = useTheme();

  return (
    <Box sx={{ mb: 3.5 }}>
      <SectionHeader accentColor={accentColor} title="รายชื่อที่เพิ่มเฉพาะเดือนนี้" count={rows.length} />
      <TableContainer component={Paper} variant="outlined" sx={{ maxHeight: 320 }}>
        <Table size="small" stickyHeader>
          <TableHead>
            <TableRow>
              <TableCell sx={{ bgcolor: lighten(accentColor, 0.88), fontWeight: 700 }}>ชื่อ</TableCell>
              <TableCell sx={{ bgcolor: lighten(accentColor, 0.88), fontWeight: 700 }}>ประเภท</TableCell>
              <TableCell align="right" sx={{ bgcolor: lighten(accentColor, 0.88), fontWeight: 700 }}>ค่าจ้างเดือน</TableCell>
              <TableCell align="right" sx={{ bgcolor: lighten(accentColor, 0.88), fontWeight: 700 }}>เงินสมทบ</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {rows.length === 0 && (
              <EmptyRow colSpan={4} icon={<PersonAddIcon />} text="ยังไม่มีคนที่เพิ่มไว้เฉพาะเดือนนี้" />
            )}
            {rows.map((row, idx) => (
              <TableRow key={row.id} hover sx={{ bgcolor: idx % 2 === 1 ? alpha(theme.palette.text.primary, 0.02) : 'transparent' }}>
                <TableCell sx={{ display: 'flex', alignItems: 'center' }}>
                  <IdCardIndicator hasIdCard={row.has_id_card} />
                  <EmployeeName id={row.employee} name={displayName(row)} />
                </TableCell>
                <TableCell>
                  <Chip size="small" label={row.employee ? 'พนักงานในระบบ' : 'ไม่มีในระบบ'} variant="outlined" />
                </TableCell>
                <TableCell align="right" sx={{ fontVariantNumeric: 'tabular-nums' }}>{formatCurrency(row.salary)}</TableCell>
                <TableCell align="right" sx={{ fontVariantNumeric: 'tabular-nums' }}>{formatCurrency(row.sso)}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
}
